import * as React from 'react'

import type { Params } from 'modules/core/components/Inputs/AutoSaveInput'
import AutoSaveInput from 'modules/core/components/Inputs/AutoSaveInput'

type AutoSaveInputProps = React.ComponentProps<typeof AutoSaveInput>

interface Props {
  isSelect?: AutoSaveInputProps['isSelect']
  onSubmit?: AutoSaveInputProps['onSubmit']
}

const ControlInput = ({ isSelect, onSubmit, children }: Props & React.ConsumerProps<Params>) => {
  return (
    <AutoSaveInput onSubmit={() => onSubmit && onSubmit()} isSelect={isSelect}>
      {(params: Params) => children(params)}
    </AutoSaveInput>
  )
}

export default ControlInput
